<template>
  <b-card class="m-0">
    <h3 class="modal-title mb-3" >Informe de la terapia</h3>

    <b-card-text>
      <b>Paciente: </b> 
      {{ dataTerapia.nombrePaciente }}
    </b-card-text>

    <b-card-text>
      <b>Tipo Terapia: </b>{{ dataTerapia.tipoText }}
    </b-card-text>


    <div class="my-1">
      <b>Código de terapia:</b>
      {{ dataTerapia.codigo }}
    </div>

    <div class="my-1">
      <b>Fecha de terapia:</b>
      {{ dataTerapia.fechaProgramada }}
    </div>

    <div class="my-1">
      <b>Terapista:</b>
    </div>
    
    <div class="my-1">
      <b>Procedimiento Aplicado:</b>
      <textarea
        class="form-control"
        v-model="procedimientoAplicado"
      />
    </div>

    <div class="my-1">
      <b>FIRMA</b>
    </div>

    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-button 
          variant="secondary" 
          @click="onCancel"
          class="mr-1"
        > 
          Cancelar 
        </b-button>

        <b-button variant="primary" @click="onProcesarTerapia"> Agregar </b-button>
      </b-col>
    </b-row>
  </b-card>
    
</template>

<script>
export default {
  name: 'FormTerapiaRespiratoria',

  props: {
    dataTerapia:{
      type: Object,
      required: false
    },
  },

  data() {
    return {
      procedimientoAplicado: null,
    }
  },

  methods: {
    onCancel() {
      console.log('oncancel');
    },

    onProcesarTerapia(){
      console.log('procesar Terapia')
    }
  }
}
</script>
